module.exports = __webpack_public_path__ + "static/media/bullhorn.2e391fc3.svg";